import { IconProps, iconA11yProps } from '../types';

export const Edit = ({ classNames, label }: IconProps) => (
    <svg
        className={classNames}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...iconA11yProps(label)}
    >
        <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" />
        <path d="M13.5 6.5l4 4" />
    </svg>
);
